<template>
  <div class="wrapper">
    <div class="home-bk3">
      <div class="wrap2">
        <div class="f-34 f-b">{{ lanuage("10228", "Food & Beverage") }}</div>
      </div>
      <div class="wrap2">
        <template v-if="goods.length">
          <div class="food-list">
            <ul class="cf">
              <li v-for="(v, i) in goods" :key="i" v-if="i < maxlist">
                <div class="w">
                  <dl class="cf">
                    <dt class="fl mag-r-20">
                     
                      <a :href="'#/sell/detail?id=' + v.code">
                        <img  :src="v.imgurl ? v.imgurl : '/'"  :onerror="errorImg_f"  style="object-fit: cover;" />
                      </a>
                    </dt>
                    <dd class="oh">
                      <div class="t1 f-24 mag-b-10 ellipsis-2">
                        <a :href="'#/sell/detail?id=' + v.code">{{ v.name }}</a>
                      </div>
                      <div class="t2 ellipsis f-16 mag-b-10">{{ v.desc }}</div>
                      <div class="b7" style="display: none;">{{ v.time }}</div>

                      <div class="bot">
                        <div class="fiex1">
                          <div class="t3 mag-b-5 mag-t-5 fiex">
                            <span class="">{{
                              lanuage("10078", "Original Price")
                            }}</span>
                            <div class="mag-l-20">
                              <span class="f-30">RM</span>
                              <span class="f-30">{{
                                v.price2.balancePrice
                              }}</span>
                            </div>
                          </div>
                          <div
                            class="fiex"
                            v-if="v.price1 && v.price1.balancePrice"
                          >
                            <div class="t4 fiex">
                              <i class="f-16 mag-r-10">{{
                                lanuage("10090", "Member")
                              }}</i>
                              <span class="f-22"
                                >RM{{ v.price1.balancePrice }}</span
                              >
                            </div>
                          </div>
                          <div class="bank30" v-else></div>
                        </div>

                        <div class="mag-t-10" style="min-height: 45px">
                          <template v-if="v.num == 0">
                            <div
                              style="display: inline-block"
                              @click.stop="handlePlus(v)"
                            >
                              <span class="t5">
                                <img src="../../assets/images/icon9.png" />
                              </span>
                            </div>
                          </template>
                          <template v-else>
                            <div class="el-input-number">
                              <span
                                role="button"
                                class="el-input-number__decrease"
                                @click.stop="handleMinus(v)"
                                ><i class="el-icon-minus"></i
                              ></span>
                              <span
                                role="button"
                                class="el-input-number__increase"
                                @click.stop="handlePlus(v)"
                                ><i class="el-icon-plus"></i
                              ></span>
                              <div class="el-input">
                                <!---->
                                <input
                                  class="el-input__inner"
                                  v-model="v.num"
                                  type="number"
                                  readonly="readonly"
                                />
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </dd>
                  </dl>
                </div>
              </li>
            </ul>
            <div
              class="more f-16 mag-t-20 pad-b-20"
              v-if="goods.length > 4 && maxlist != 100"
            >
              <a href="javascript:;" @click="maxlist = 100">{{
                lanuage("10030", "Expand More")
              }}</a>
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="null center fiex"
            style="height: 390px; justify-content: center"
          >
            <div>
              <img style="width: 100px; height: 100px" src="/static/404.png" />
              <!-- <p class="mag-t-20">{{ lanuage("10226", "No Hot Showing") }}</p> -->
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="cart-bottom" :class="buyclass">
      <div class="wrap2 fiex" style="justify-content: flex-end">
        <div class="t1">
          <i v-if="shopNum > 0">{{ shopNum || 0 }}</i
          ><img src="../../assets/images/icon13.png" />
        </div>
        <div class="t2 mag-l-40 mag-r-40">
          <span class="f-18">{{ lanuage("10229", "Total") }} :</span>
          <span class="f-18">RM</span>
          <span class="f-22">{{ shopMoney || 0 }}</span>
        </div>
        <div class="t3 f-16">
          <a
            href="javascript:;"
            @click="goBuy(1)"
            v-if="shopNum > 0"
            class="com-bon"
            >{{ lanuage("10230", "Buy Now") }}</a
          >
          <a
            href="javascript:;"
            style="background: #666; color: #ccc"
            v-else
            class="com-bon"
            >{{ lanuage("10230", "Buy Now") }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { mapState, mapMutations, mapActions } from "vuex";
import { queryCardProducts, getGoods } from "@/api/shop.js";
import { accAdd } from "@/utils/util.js";
export default {
  props: {},
  data() {
    return {
      maxlist: 4,
      cardInfo: "",
      cardHolder: [],
      goods: [], // 配送到家
      goodsHome: [], // 影院取货
      memberList: {},
      dispatchingHomeVo: {}, // 配送到家规则
      shoppingCard: {}, //配送到家假的购物车
      shopNum: 0, //配送到家
      tab: "cinemaBuy",
      shopMoney: 0, //配送到家
      cartPop: false, //配送到家
      cinemaCard: {}, //影院取货假的购物车
      cinemaShopNum: 0, //影院取货
      cinemaShopMoney: 0, //影院取货
      cinemaCartPop: false, //影院取货
      list: [],
      buyclass: "",
    };
  },
  created() {
    var that = this;
    $(window).scroll(function () {
      console.log(123);
      var s = $(this).scrollTop();
      //
      if ($(".home-bk3").length) {
        var s2 = $(".home-bk3").offset().top;
        if (s + Math.floor($(window).height()) - 200 > s2) {
          that.buyclass = "scroll";
        } else {
          that.buyclass = "";
        }
      }
    });

    this.getGetgoods();
    this.setShopType(1);
    // console.log(this.shop.deliveryShopCart, 'this.shop.deliveryShopCart')
    if (this.shop.deliveryShopCart && this.shop.deliveryShopCart.length > 0) {
      this.shop.deliveryShopCart.forEach((e, i) => {
        this.shopNum += e.num;
        this.shopMoney = accAdd(
          e.payPrice.balancePrice * e.num,
          this.shopMoney
        );
      });
      this.setDeliveryShopCart(this.shop.deliveryShopCart);
    }
    // this.getCardList()
  },
  computed: {
    // 用户
    ...mapState(["userInfo"]),
    ...mapState(["shop", "cinemaShopCart"]),
    ...mapState(["shop", "deliveryShopCart"]),
  },
  methods: {
    ...mapActions("shop", ["setCinemaShopCart"]),
    ...mapActions("shop", ["setDeliveryShopCart"]),
    ...mapActions("shop", ["setShopType"]),
    ...mapActions("shop", ["setShopText"]),
    cartChange(data, t) {
      if (t == 1) {
        this.shopNum = 0;
        this.shopMoney = 0;
        data.forEach((e, i) => {
          this.shopNum += e.num;
          this.shopMoney = accAdd(
            e.payPrice.balancePrice * e.num,
            this.shopMoney
          );
        });
      } else {
        this.cinemaShopNum = 0;
        this.cinemaShopMoney = 0;
        console.log(data);
        data.forEach((e, i) => {
          this.cinemaShopNum += e.num;
          this.cinemaShopMoney = accAdd(
            e.payPrice.balancePrice * e.num,
            this.cinemaShopMoney
          );
        });
      }
    },
    goBuy(type) {
      let url = "";

      this.setShopText(this.dispatchingHomeVo.deliveryText);
      url = "/tickets/shop_order";
      this.$router.push(url);
    },
    handleMinus(itm) {
      if (itm.num <= 0) {
        return;
      }
      itm.num--;
      // 0 影院取货 1 配送到家
      if (1) {
        this.shopNum = 0;
        this.shopMoney = 0;
        this.shoppingCard = this.goods.filter((e, i) => {
          return e.num > 0;
        });
        this.setShopType(1);
        this.setDeliveryShopCart(this.shoppingCard);
        this.shoppingCard.forEach((e, i) => {
          this.shopNum += e.num;
          this.shopMoney = accAdd(
            e.payPrice.balancePrice * e.num,
            this.shopMoney
          );
          // this.shopMoney += e.payPrice.balancePrice*e.num
        });
        if (this.shoppingCard.length == 0) {
          this.cinemaCartPop = false;
          return;
        }
      }
    },
    handlePlus(itm) {
      if (!this.userInfo.mobile) {
        this.$router.push("/login/index");
        return;
      }
      if (1) {
        // 卖品只能买6个
        if (this.shopNum < 6) {
          this.shopNum = 0;
          this.shopMoney = 0;
          itm.num++;
          // 和购物车匹配
          this.shoppingCard = this.goods.filter((e, i) => {
            return e.num > 0;
          });
          this.setShopType(1);
          this.setDeliveryShopCart(this.shoppingCard);
          this.shop.deliveryShopCart.forEach((e, i) => {
            this.shopNum += e.num;
            this.shopMoney = accAdd(
              e.payPrice.balancePrice * e.num,
              this.shopMoney
            );
          });
        } else {
          this.$alert(this.lanuage("10238", "一个订单最多购买6份卖品"));
        }
      }
    },
    handleShow() {
      this.show = true;
    },

    // 获取卖品列表
    async getGetgoods() {
      try {
        let res = await getGoods({
          methods: "post",
        });
        this.list = res.data;
        // console.log('获取卖品', res)
        let goods = res.data || [];

        // 处理列表，将会员价格：price1，普通价格：price2，实际支付价格：price
        this.goods = goods.map((e) => {
          let prc = {};
          for (let p of e.price) {
            prc["p" + p.priceType] = p;
          }
          //比对缓存中购物车
          let num = 0;
          if (
            this.shop.deliveryShopCart &&
            this.shop.deliveryShopCart.length > 0
          ) {
            this.shop.deliveryShopCart.forEach((ee) => {
              if (e.code == ee.code) {
                num = ee.num;
              }
            });
          }
          return {
            id: e.id,
            code: e.code,
            name: e.name,
            imgurl: e.imgurl,
            desc: e.describe,
            time: e.instruction,
            price1: prc.p1 || "",
            price2: prc.p2 || "",
            recommend: e.recommend,
            advanceSale: e.advanceSale,
            enableDelivery: e.enableDelivery,
            num: num || 0,
            payPrice:
              this.userInfo.userType === 1
                ? prc.p1 || prc.p2
                : prc.p2 || prc.p1,
          };
        });
      } catch (e) {
        console.error("卖品列表", e);
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/sell/shop.vue